import { useEffect } from "react";
import { LocationListener } from "history";
import { history } from "state/configureStore";

export const useHistoryChange = <T>(
  callback: LocationListener<T | undefined>
) => {
  useEffect(() => {
    // NOTE: need casting as history state hardcoded to `unknown` in react-router
    const clearListener = history.listen(callback as LocationListener<unknown>);

    return () => {
      clearListener();
    };
  }, [callback]);
};
